import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { SharedDataService } from '../../../helper/services/shared-data.service';
import { AuthService } from '../../../helper/services/auth.service';
import { ClinicManagerService } from '../../../networking/services/clinic-manager.service';
import { ChangeTrackerService } from '../../../helper/services/change-tracker.service';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { ChangePasswordDialogComponent } from '../../dialogs/change-password-dialog/change-password-dialog.component';
import { CONSTANTS } from '../../../helper/constants';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-bottom-bar',
  imports: [CommonModule, RouterModule, MatButtonModule],
  templateUrl: './bottom-bar.component.html',
  styleUrl: './bottom-bar.component.scss'
})
export class BottomBarComponent {
  version: string = environment.version
  constants = CONSTANTS

  constructor(
    public sharedDataService: SharedDataService,
    private authService: AuthService,
    private clinicManagerService: ClinicManagerService,
    private changeTrackerService: ChangeTrackerService,
    private dialog: MatDialog
  ) {}

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn()
  }

  async logout(): Promise<void> {
    if (this.changeTrackerService.hasChanges()) {
      const ref = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Ausloggen',
          message: 'Du hast ungespeicherte Änderungen. Wenn du dich ausloggst, gehen diese verloren.',
          confirmText: 'Ausloggen'
        }
      })
      const confirmed = await firstValueFrom(ref.afterClosed())
      if (!confirmed) return
    }
    this.changeTrackerService.clear()
    this.clinicManagerService.logoutUser()
  }

  openChangePassword(): void {
    this.dialog.open(ChangePasswordDialogComponent, {
      width: '420px',
      disableClose: true
    })
  }
}
